/**
 * Fallback estático de labels hasta que crm_campo_labels_i18n esté poblado (script DeepL).
 * Prioridad: BD (labelsMap) → diccionario UI por texto ES → texto ES del componente.
 */
import { translateUiString } from "../utils/propiedadUiStrings";

const FALLBACK = {
  ca: {
    "seccion:cabecera": "Principals",
    "seccion:generales": "Generals",
    "seccion:distribucion": "Distribució",
    "seccion:equipamiento": "Equipament",
    "seccion:ubicacion": "Ubicació",
    "seccion:economicos": "Econòmics",
    "seccion:alquiler": "Lloguer",
    "seccion:localizacion": "Localització",
    "seccion:multimedia": "Multimèdia",
    "seccion:publicacion": "Web",
    "seccion:propietarios": "Contactes",
    "seccion:internos": "Interns",
    "seccion:registro": "Registre",
    "seccion:notasimple": "Nota Simple",
    "seccion:documentacion": "Documentació",
    "seccion:historial": "Historial",
    web_titulo: "Títol de l'immoble",
    web_desc_corta_es: "Descripció curta",
    web_desc_larga_es: "Descripció llarga",
  },
  en: {
    "seccion:cabecera": "Main",
    "seccion:generales": "General",
    "seccion:distribucion": "Layout",
    "seccion:equipamiento": "Features",
    "seccion:ubicacion": "Location",
    "seccion:economicos": "Financial",
    "seccion:alquiler": "Rental",
    "seccion:localizacion": "Address",
    "seccion:multimedia": "Media",
    "seccion:publicacion": "Web",
    "seccion:propietarios": "Contacts",
    "seccion:internos": "Internal",
    "seccion:registro": "Land registry",
    "seccion:notasimple": "Land registry note",
    "seccion:documentacion": "Documents",
    "seccion:historial": "History",
    web_titulo: "Property title",
    web_desc_corta_es: "Short description",
    web_desc_larga_es: "Long description",
    operacion: "Transaction",
    tipo_inmueble_nombre: "Property type",
    m2_construidos: "Built area m²",
    num_dormitorios: "Bedrooms",
    precio_venta: "Sale price",
    nombre_via: "Street name",
    poblacion_nombre: "Town",
  },
  de: {
    "seccion:cabecera": "Hauptdaten",
    "seccion:generales": "Allgemein",
    "seccion:distribucion": "Aufteilung",
    "seccion:equipamiento": "Ausstattung",
    "seccion:ubicacion": "Lage",
    "seccion:economicos": "Wirtschaftlich",
    "seccion:alquiler": "Miete",
    "seccion:localizacion": "Adresse",
    "seccion:multimedia": "Medien",
    "seccion:publicacion": "Web",
    "seccion:propietarios": "Kontakte",
    "seccion:internos": "Intern",
    "seccion:registro": "Grundbuch",
    "seccion:notasimple": "Grundbuchauszug",
    "seccion:documentacion": "Dokumente",
    "seccion:historial": "Verlauf",
    web_titulo: "Objekttitel",
    web_desc_corta_es: "Kurzbeschreibung",
    web_desc_larga_es: "Langbeschreibung",
  },
  fr: {
    "seccion:cabecera": "Principales",
    "seccion:generales": "Général",
    "seccion:distribucion": "Distribution",
    "seccion:equipamiento": "Équipement",
    "seccion:ubicacion": "Emplacement",
    "seccion:economicos": "Économique",
    "seccion:alquiler": "Location",
    "seccion:localizacion": "Localisation",
    "seccion:multimedia": "Multimédia",
    "seccion:publicacion": "Web",
    "seccion:propietarios": "Contacts",
    "seccion:internos": "Interne",
    "seccion:registro": "Registre",
    "seccion:notasimple": "Note simple",
    "seccion:documentacion": "Documentation",
    "seccion:historial": "Historique",
    web_titulo: "Titre du bien",
    web_desc_corta_es: "Description courte",
    web_desc_larga_es: "Description longue",
    operacion: "Opération",
    tipo_inmueble_nombre: "Type de bien",
    m2_construidos: "m² construits",
    num_dormitorios: "Chambres",
    precio_venta: "Prix de vente",
    nombre_via: "Nom de la voie",
    poblacion_nombre: "Ville",
  },
  nl: {
    "seccion:publicacion": "Web",
    web_titulo: "Titel van het pand",
    web_desc_corta_es: "Korte beschrijving",
    web_desc_larga_es: "Lange beschrijving",
  },
  it: {
    "seccion:publicacion": "Web",
    web_titulo: "Titolo dell'immobile",
    web_desc_corta_es: "Descrizione breve",
    web_desc_larga_es: "Descrizione lunga",
  },
  pl: {
    "seccion:publicacion": "Web",
    web_titulo: "Tytuł nieruchomości",
    web_desc_corta_es: "Krótki opis",
    web_desc_larga_es: "Długi opis",
  },
  ru: {
    "seccion:publicacion": "Web",
    web_titulo: "Название объекта",
    web_desc_corta_es: "Краткое описание",
    web_desc_larga_es: "Подробное описание",
  },
  uk: {
    "seccion:publicacion": "Web",
    web_titulo: "Назва об'єкта",
    web_desc_corta_es: "Короткий опис",
    web_desc_larga_es: "Детальний опис",
  },
};

export function fallbackLabel(lang, key, esFallback) {
  if (!lang || lang === "es") return esFallback;
  const fromKey = FALLBACK[lang]?.[key];
  if (fromKey) return fromKey;
  return translateUiString(lang, esFallback);
}
